<template lang="html">
    <div class="artworks-list cards">
      <ArtworkCard
        v-for="post in artworks"
        :key='post.sku'
        :id='post.id'
        :title='post.title'
        :image='post.image'
        :artist='post.artist'
        :description='post.description'
        />
    </div>
</template>

<script>
import ArtworkCard from './ArtworkCard.vue'

export default {
  name: 'ArtworksList',
  props: ["artworks"],
  components : {
    ArtworkCard
  }
}
</script>

<style lang="scss" scoped>

.cards {
    list-style: none;
    padding: 0;

    display: flex;
    // flex-direction: row;
    flex-flow: row wrap;

    // @include media-query($on-palm) {
    //   display: block;
    //   margin: 0
    // }

}

/* @media screen and (max-device-width: 40rem) {
    max-width: 100%;
} */
</style>
